import { vservice } from '@niknevis/vue-modules'
import { ContentItemSendToQueueRequestModel } from '@/modules/content-item/models/content-item-request.model'
import { AdminContentItemService } from '@/modules/content-item/services/admin-content-item.service'

@vservice()
export class AdminContentItemSendToQueueUseCase {
  isLoading = false
  isSuccess = false

  constructor(
    private readonly adminContentItemService: AdminContentItemService
  ) {
  }

  execute(contentItemId: number, contentItem: ContentItemSendToQueueRequestModel): Promise<any> {
    return this.adminContentItemService.sendToQueue(contentItemId, contentItem)
      .onStart(progress => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

}
